import React from 'react';
import PropTypes from 'prop-types';
import IntlMessage from "../../../../../helpers/intlMessage";
import TableReport from '@componentes/TableReport';

function Arquivamento ({ lista }) {
  const headerListItens = [
    <IntlMessage id = "dashboards.reports.dateArchiving"/>,
    <IntlMessage id = "dashboards.reports.type"/>,
    <IntlMessage id = "general.materialArchiving.identification"/>,
    <IntlMessage id = "dashboards.reports.exam"/>,
    <IntlMessage id = "general.materialArchiving.ArchivingReason"/>
  ];

  return (
    <TableReport
      title={<IntlMessage id = "dashboards.reports.reportArchiving"/>}
      // assinatura={<IntlMessage id = "dashboards.reports.subscriptionCRM"/>}
      headerList={headerListItens}
      assinaturaVisible={false}
    >
      {lista.map((item, i) => (
        <tr key={i}>
          <td>{item.dataArquivamento}</td>
          <td>{item.tipo}</td>
          <td>{item.identificacao}</td>
          <td>{item.nrExame}</td>
          <td>{item.obs}</td>
        </tr>
      ))}
    </TableReport>
  );
}

Arquivamento.propTypes = {
  lista: PropTypes.array.isRequired
};

Arquivamento.defaultProps = {
  lista: []
};

export default Arquivamento;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/common/components/Arquivamento/index.js